import { LOGIN_FAILURE, REGISTER_FAILURE, SET_ALLOW_RECOMMENDATIONS, SET_EMAIL_USER, SET_FIRST_NAME, SET_LAST_NAME, SET_PASSWORD_USER,
    SET_PHONE_USER, SET_STATUS, SET_USERNAME, SET_CONFIRM_EMAIL_USER } from '../actions/auth';

export const STATUS_AUTH_IDLE = 'idle';
export const STATUS_AUTH_LOADING = 'loading';
export const STATUS_AUTH_FAILED = 'failed';
export const STATUS_AUTH_SUCCEEDED = 'succeeded';

const initialState = {
    username: null,
    status: STATUS_AUTH_IDLE,
    email: '',
    confirmEmail: '',
    password: '',
    firstName: '',
    lastName: '',
    phone: '',
    allowRecommendations: false,
    error: null,
    errorRegister: null,
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case SET_EMAIL_USER:
            return {
                ...state,
                email: action.payload,
            };
        case SET_CONFIRM_EMAIL_USER:
            return {
                ...state,
                confirmEmail: action.payload,
            };
        case SET_PASSWORD_USER:
            return {
                ...state,
                password: action.payload,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case REGISTER_FAILURE:
            return {
                ...state,
                errorRegister: action.payload,
            };
        case SET_USERNAME:
            return {
                ...state,
                username: action.payload,
            };
        case SET_STATUS:
            return {
                ...state,
                status: action.payload,
            };
        case SET_FIRST_NAME:
            return {
                ...state,
                firstName: action.payload,
            };
        case SET_LAST_NAME:
            return {
                ...state,
                lastName: action.payload,
            };
        case SET_PHONE_USER:
            return {
                ...state,
                phone: action.payload,
            };
        case SET_ALLOW_RECOMMENDATIONS:
            return {
                ...state,
                allowRecommendations: action.payload,
            };
        default:
            return state;
    }
};

export default auth;
